export default {
  path: '/setup_definitions',
  name: 'setup_definitions',
  component: () => import('../components/setupdefinition/Layout'),
  redirect: { name: 'SetupDefinitionList' },
  meta: {
    breadcrumb: 'profile.setupdefinition.definitions',
  },
  children: [
    {
      name: 'SetupDefinitionList',
      path: '',
      component: () => import('../views/setupdefinition/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'SetupDefinitionCreate',
      path: 'new',
      component: () => import('../views/setupdefinition/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'SetupDefinitionUpdate',
      path: ':id/edit',
      component: () => import('../views/setupdefinition/Update'),
      meta: {
        breadcrumb: 'profile.setupdefinition.definition',
      },
    },
    {
      name: 'SetupDefinitionShow',
      path: ':id',
      component: () => import('../views/setupdefinition/Show'),
      meta: {
        breadcrumb: 'profile.setupdefinition.definition',
      },
    },
    {
      name: 'SetupDefinition',
      path: ':parent',
      component: () => import('../components/setupdefinitionsub/Layout'),
      meta: {
        breadcrumb: 'profile.setupdefinition.definition',
      },
      children: [
        {
          name: 'SetupDefinitionSubShow',
          path: ':id',
          component: () => import('../views/setupdefinitionsub/Show'),
          meta: {
            breadcrumb: 'profile.setupdefinition.definitionsub',
          },
        },
        {
          name: 'SetupDefinitionSubUpdate',
          path: ':id/edit',
          component: () => import('../views/setupdefinitionsub/Update'),
          meta: {
            breadcrumb: 'profile.setupdefinition.definitionsub',
          },
        },
        {
          name: 'SetupDefinitionSubCreate',
          path: 'new',
          component: () => import('../views/setupdefinitionsub/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
